import React from 'react';
// import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import money from './../../../../assets/images/svg/109-money.svg';
import archives from './../../../../assets/images/svg/111-archives.svg';

export const Header = ({ roles }) => {
	// const router = useSelector(state => state.router);



	return (
		<div className="container-fluid">
			<nav className="navbar navbar-expand-lg navbar-light px-0 mb-2">
				<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
					<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
				</button>
				<div className="collapse navbar-collapse flex-column" id="navbarNav">
					<hr className="d-lg-none" />
					<ul className="nav nav-fill nav-pills bg-lg-dim rounded-max">
						<NavLink exact to="/facilita/settings" activeClassName="active" className="nav-item text-uppercase rounded-inherit ml-lg-0 w-auto flex-md-grow-1">
							<div className="nav-link py-1">Profil de l'utilisateur</div>
						</NavLink>
						<div className="w-100 mt-1 d-sm-none"></div>
						<NavLink to="/facilita/settings/securite" activeClassName="active" className="nav-item w-auto flex-md-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Securité</div>
						</NavLink>
						<NavLink to="/facilita/settings/invoicing" activeClassName="active" className="nav-item w-auto flex-md-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Facturation</div>
						</NavLink>
						<div className="w-100 mt-1 d-sm-none"></div>
						<NavLink exact to="/legal/terms" activeClassName="active" target="_blank" className="nav-item w-auto flex-lg-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Mentions Légales</div>
						</NavLink>
						{/* <div className="w-100 mt-2 d-sm-none"></div> */}
						{roles.includes("ADMIN") &&
							<a href="/backoffice" className="nav-item w-auto flex-md-grow-1 text-uppercase rounded-inherit">
								<div className="nav-link py-1 px-0">Backoffice</div>
							</a>}
					</ul>
					<hr className="d-lg-none mb-0" />
				</div>
			</nav>
		</div>
	);
};